import Localized from 'src/constants/AppStrings';
import Styles from 'src/components/Styles';
import BackSubheader from 'src/components/elements/BackSubheader';
import React from 'react';
import {SendSnackDescriberData} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import Util from 'src/Util';
import AccountStore from 'src/stores/AccountStore';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import AVText from 'src/components/elements/AVText';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import {Platform} from 'react-native';
import SnackDetailsRefive from 'src/components/img/svg/SnackDetailsRefive';

export function getBackSubHeaderDescriptor(): JSX.Element {
  return <BackSubheader title="" />;
}

export function renderSnackMsgDescriptor(
  props: SendSnackDescriberData,
): string | string[] {
  const {amount, senderName} = props;
  const str = Localized.Labels.you_have_received_a_snack;
  return Localized.Labels.formatString(
    str,
    Util.formatCurrency(amount, amount, AccountStore.getCurrency()),
    senderName,
  );
}
const getSenderTitle = (_props) => {
  return ['e', 'c'].indexOf(_props.status.toLowerCase()) > -1
    ? Localized.Labels.my_account
    : Localized.Labels.your_snack_sent;
};
export function getTopHeaderSnackDescriptor(
  props: SendSnackDescriberData,
): JSX.Element {
  return (
    <React.Fragment>
      <SnackDetailsRefive />
      <AVText
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
        style={getSendSnackStyleDescriptor().appTitleStyle}
        accessible
        testID="qa_SendSnackType_txt"
        nativeID="qa_SendSnackType_txt"
      >
        {props.isSender
          ? getSenderTitle(props)
          : Localized.Labels.formatString(
              Localized.Labels.sent_you_snack_desc,
              props.senderName,
            )}
      </AVText>
      <AVText
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
        style={getSendSnackStyleDescriptor().dateStyle}
        accessible
        testID="qa_SendSnackTime_txt"
        nativeID="qa_SendSnackTime_txt"
      >
        {props.snackDate}
      </AVText>
    </React.Fragment>
  );
}

export function getSnackStickerDescriptor(): JSX.Element {
  return null;
}

export function titleDescriptor(): string | string[] {
  return Localized.Labels.send_a_snack_title;
}

export function snackErrorTextDescriptor() {
  return Localized.Errors.one_time_snack_refive_error_desc;
}

export function snackDetailsBtnFontSTyle() {
  return {fontFamily: Styles.FontFamily.figtreeRegular};
}
export function referralSummaryBtnTextFont() {
  return {
    fontFamily: Styles.FontFamily.figtreeRegular,
    fontSize: Styles.Fonts.f7,
  };
}

export function getBlockUserBtn({onBlockUser}) {
  return (
    <RoundedButton
      buttonType={ButtonType.outline}
      text={Localized.Buttons.block_user}
      containerStyle={getSendSnackStyleDescriptor().btnBlockUser}
      backgroundColor={blockUnblockButtonColor()}
      color={Styles.dangerColor}
      onPress={onBlockUser}
      accessibilityLabel="Block Snack User"
      textStyle={[
        {textAlign: 'center'},
        getSendSnackStyleDescriptor().btnBlockUserText,
      ]}
      accessible
      testID="qa_BlockUser_btn"
    />
  );
}
export function getUnBlockUserBtn({onUnBlockUser}) {
  return (
    <RoundedButton
      buttonType={unblockButtonType()}
      text={Localized.Labels.unblock_user}
      backgroundColor={blockUnblockButtonColor()}
      containerStyle={getSendSnackStyleDescriptor().btnBlockUser}
      color={Styles.dangerColor}
      accessibilityLabel="Blocked"
      textStyle={getSendSnackStyleDescriptor().btnBlockUserText}
      onPress={onUnBlockUser}
      accessible
      testID="qa_UnblockUser_btn"
      nativeID="qa_UnblockUser_btn"
    />
  );
}

export function getAcceptSnackButton({
  acceptSnack,
  snackDetails,
  context,
  isAcceptButtonVisible,
}) {
  return (
    isAcceptButtonVisible && (
      <RoundedButton
        accessibilityLabel="Accept Snack"
        buttonType={ButtonType.action}
        color={acceptButtonColor()}
        text={Localized.Buttons.accept_snack}
        textStyle={getSendSnackStyleDescriptor().btnAccept}
        onPress={() =>
          acceptSnack({
            snackDetails,
            context,
          })
        }
      />
    )
  );
}

export function backHeaderStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    backgroundColor:
      Platform.OS === 'web' ? Styles.white : Styles.tabBarBackgroundColor,
  };
}

export function unblockButtonType() {
  return ButtonType.outline;
}
export function acceptButtonColor() {
  return Styles.Colors.Refive.activeFooterBlue;
}
export function blockUnblockButtonColor() {
  return Styles.white;
}

export function getAcceptSnackBtn(props, appContext) {
  return (
    <RoundedAppButton
      accessibilityLabelValue="Accept Snack"
      buttonType={RoundedAppButtonType.Solid}
      titleText={Localized.Buttons.accept_snack_redesign}
      onPress={() =>
        props.acceptSnack({
          snackDetails: props.snackDetails,
          context: appContext,
        })
      }
      buttonContainerStyle={{
        alignSelf: 'flex-end',
        marginRight: Styles.Spacing.m3,
        marginBottom: Styles.Spacing.m3,
      }}
    />
  );
}

export function blockUserBtnStyle() {
  return Styles.white;
}

export function getSendSnackStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    topRow: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      marginBottom: Styles.Spacing.m3,
    },
    content: {
      padding: Styles.Spacing.m3 + Styles.Spacing.m2,
      flex: 1,
      backgroundColor:
        Platform.OS === 'web' ? Styles.white : Styles.tabBarBackgroundColor,
    },
    senderSnackStatusText: {
      color: Styles.black,
      flex: 1,
      marginTop: Styles.Spacing.m2,
      fontSize: Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.figtreeRegular,
    },
    appTitleStyle: {
      color: Styles.black,
      fontSize: Styles.Fonts.sectionHeader,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.figtreeRegular,
      flex: 1,
    },
    dateStyle: {
      color: Styles.black,
      fontSize: Styles.Fonts.f8,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.figtreeRegular,
      top: 2,
    },
    description: {
      flex: 1,
      marginTop: Styles.Spacing.m1,
      color: Styles.black,
      fontSize: Styles.Fonts.f1,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.figtreeRegular,
    },
    message: {
      color: Styles.black,
      flex: 1,
      marginTop: Styles.Spacing.m2,
      fontSize: Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.figtreeRegular,
    },
    receiverSnackStatusText: {
      flex: 1,
      textAlign: 'center',
      color: Styles.black,
      fontSize: Styles.Fonts.f7,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.figtreeRegular,
    },
    amount: {
      color: Styles.black,
      fontSize: Styles.Fonts.f11 + 8,
      fontFamily: Styles.FontFamily.comodoVintage,
    },
    btnBlockUser: {
      alignSelf: 'center',
      marginTop: Styles.Spacing.m3,
      paddingVertical: 8,
      paddingHorizontal: 18,
      borderWidth: 2,
    },
    btnBlockUserText: {
      fontSize: Styles.Fonts.f1,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.figtreeRegular,
    },
    btnAccept: {
      fontSize: Styles.Fonts.f1,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.figtreeRegular,
    },
    btnAcceptSnack: {
      paddingVertical: 8,
      paddingHorizontal: 18,
    },
    blockUserHeaderText: {
      color: Styles.black,
      fontSize: Styles.Fonts.f8,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.figtreeRegular,
      marginBottom: Styles.Spacing.m2,
    },
    blockUserHeaderTextDesc: {
      color: Styles.black,
      fontSize: Styles.Fonts.f8,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.figtreeRegular,
    },
    scrollViewContent: {
      flexGrow: 1,
      paddingBottom: Styles.Spacing.m5 + Styles.Spacing.m4,
    },
  };
}

export function snackMessageContainerStyle() {
  return {
    maxHeight: 130,
    minHeight: 130,
  };
}

export function snackMessageContentStyle() {
  return {
    paddingBottom:
      Platform.OS === 'ios' ? Styles.Spacing.m4 * 3 : Styles.Spacing.m4,
    paddingTop: Styles.Spacing.m2,
  };
}

export default {
  getBackSubHeaderDescriptor,
  getTopHeaderSnackDescriptor,
  getSnackStickerDescriptor,
  renderSnackMsgDescriptor,
  getSendSnackStyleDescriptor,
  getAcceptSnackBtn,
  blockUserBtnStyle,
  backHeaderStyleDescriptor,
  unblockButtonType,
  titleDescriptor,
  blockUnblockButtonColor,
  acceptButtonColor,
  getBlockUserBtn,
  snackDetailsBtnFontSTyle,
  snackMessageContainerStyle,
  snackErrorTextDescriptor,
  snackMessageContentStyle,
  getAcceptSnackButton,
  referralSummaryBtnTextFont,
  getUnBlockUserBtn,
};
